import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles  } from '@material-ui/core/styles';

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: '660px',
  },
  link: {
    color: '#00C3B4',
  },
  disabled: {
    color: '#B6B8B4',
  },
  primary: {
    color: theme.palette.primary.dark,
  },
  timelinedot: {
    width: 15,
    height: 15
  }
}));

export default function Section(props) {
  const classes = useStyles();
  const {
    sectionName,
    title,
    currency,
    value,
    frequency,
    coverages,
    sectionName2,
    isEcg = false,
  } = props;

  
  return (
    <>
      <Grid item>
        <Typography variant="body1" color="primary">

          <Timeline align="left">
            <TimelineItem >
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator ><TimelineDot style={{backgroundColor: "#EA635C"}} className={classes.timelinedot}/><TimelineConnector style={{backgroundColor: "#EA635C"}}/></TimelineSeparator>
              <TimelineContent>
                <Typography>
                  We need to review your application before confirming your cover and terms.
                </Typography>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator><TimelineDot style={{ backgroundColor: "#EA635C" }} className={classes.timelinedot}/> <TimelineConnector style={{backgroundColor: "#EA635C"}}/></TimelineSeparator>
              <TimelineContent>Complete the next steps and submit your application.</TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator><TimelineDot style={{backgroundColor: "#4066B3"}} className={classes.timelinedot}/> </TimelineSeparator>
              <TimelineContent>One of our underwriting experts will take a look. </TimelineContent>
            </TimelineItem>
          </Timeline>
      
          
          <p>If we need anything else, we’ll be in touch—for example, we might ask for more details or a medical examination, if needed.</p>
          <p>You can track your application status as it updates in the pipeline.</p>              
          
        </Typography>
      </Grid>

      
    </>
  );
}
